
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState('overview', {
      data: 'conversion'
    })
  } // computed
}; // export default
